import { render, staticRenderFns } from "./StoreBannerScore.vue?vue&type=template&id=2d4cf6c3&scoped=true"
import script from "./StoreBannerScore.vue?vue&type=script&lang=js"
export * from "./StoreBannerScore.vue?vue&type=script&lang=js"
import style0 from "./StoreBannerScore.vue?vue&type=style&index=0&id=2d4cf6c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4cf6c3",
  null
  
)

export default component.exports